import { useMemo } from 'react';
import { formatAmount } from '@multiversx/sdk-dapp/utils';
import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

import type { BuyA1XSchema } from '../../validations/buyA1XSchema';
import { useGetAccountTokens } from '../useGetAccountTokens';
import { useGetAshswapTokens } from './useGetAshswapTokens';

export const useSwapTokens = (control: Control<BuyA1XSchema>) => {
  const fromToken = useWatch({ control, name: 'fromToken' });
  const ashswapTokens = useGetAshswapTokens();
  const walletTokens = useGetAccountTokens();

  const tokens = useMemo(() => {
    return ashswapTokens.data ?? [];
  }, [ashswapTokens.data]);

  const fromTokenBalance = useMemo(() => {
    if (!fromToken || !walletTokens.data) return 0;
    const token = walletTokens.data.find(
      walletToken => walletToken.identifier === fromToken?.identifier
    );
    const denominatedBalance = formatAmount({
      input: token?.balance ?? '0',
      decimals: token?.decimals ?? 1,
    });

    return denominatedBalance;
  }, [walletTokens.data, fromToken]);

  return {
    tokens,
    fromTokenBalance,
    walletTokens,
    ashswapTokens,
  };
};